var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{key:_vm.updateKey},[(_vm.filter)?_c('div',[_c('editLink',{attrs:{"user":_vm.filter},on:{"close":() => {
          _vm.setFilter(_vm.filter)
        }}})],1):_vm._e(),_c('b-flix-h1',[_vm._v("Server-Logs")]),_c('loggingTable',{attrs:{"backButton":true,"ID":_vm.filter},on:{"changed":(f) => {
        _vm.filter = f
      }}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }